<template>
    <div :id="'radio--' + component_id">
        <div v-if="options_loaded && passed_filter">
            <div class="radiooption stylesoption" v-if="!loading" :data-designer-component-id="component_id">
                <span>Choose Hinge Side: <br> <small>(viewed from outside)</small></span>
                <span v-for="option in filtered_option_list"><label><input type="radio" v-model="localTarget"
                                                                           :name="'radio_' + component_id"
                                                                           :value="option.value"/> {{ option.label }}</label></span>
            </div>
            <div v-if="loading">
                <p>Loading Options</p>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import RadioQuestion from "./mixin/RadioQuestion.vue";

    export default {
        mixins: [
            RadioQuestion
        ],
        props: {
            title: {
                default(){
                    return 'Choose Hinge Side:';
                }
            },
            component_id: {
                default(){
                    return 'hinge_side';
                }
            }
        },
        computed: {
            url(){
                return '/api/options/' + this.fabricator + '/hinge-side';
            },
            cache_key(){
                return '_';
            },
        },
    }
</script>
